import React from 'react'

export const Checkbox = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className = '', ...props }, ref) => {
  return (
    <div className="relative inline-block w-6 h-6">
      <input
        type="checkbox"
        ref={ref}
        className={`
            peer absolute inset-0 opacity-0 z-[1] cursor-pointer m-0
            ${className}
          `}
        {...props}
      />
      <div
        className={`
            absolute inset-0 pointer-events-none
            rounded flex items-center justify-center
            bg-white border border-[#ccc]
            peer-checked:border-none peer-checked:bg-wove-blue
          `}
      >
        {props.checked && (
          <svg
            className="w-4 h-4 text-white"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </div>
    </div>
  )
})
